import Vue from 'vue'
import axios from '@/plugins/axiosV2'
import utils from '@/helpers/utilidades'

const http = axios(process.env.VUE_APP_API_FORMALIZACION+'/v2');

export default {
  obtener_concifigraciones() {
    return http.get(`/configuracion`);
  }

  ,obtener_concifigracion(id) {
    return http.get(`/configuracion/${id}`);
  }

  ,crear_configuracion(payload) {
    return http.post(`/configuracion`, payload);
  }

  ,editar_configuracion(id, payload) {
    return http.put(`/configuracion/${id}`, payload);
  }

  ,eliminar_configuracion(id) {
    return http.delete(`/configuracion/${id}`);
  }
}